import { BoldReportComponents } from './core';
// tslint:disable-next-line:max-line-length

import { EventEmitter, IterableDiffers, KeyValueDiffers, Component, ElementRef, ChangeDetectorRef, Input, Output } from '@angular/core';
export class BoldReportViewerComponent extends BoldReportComponents<any, any> {
	 dataSources_input: any;
	 enablePageCache_input: any;
	 exportSettings_input: any;
	 isResponsive_input: any;
	 locale_input: any;
	 pageSettings_input: any;
	 parameters_input: any;
	 toolbarSettings_input: any;
	 parameterSettings_input: any;
	 printMode_input: any;
	 printOption_input: any;
	 processingMode_input: any;
	 renderMode_input: any;
	 reportPath_input: any;
	 reportServerUrl_input: any;
	 reportServiceUrl_input: any;
	 zoomFactor_input: any;
	 serviceAuthorizationToken_input: any;
	 enableParameterBlockScroller_input: any;
	 enableDatasourceBlockScroller_input: any;
	 sizeToReportContent_input: any;
	 autoRender_input: any;
	 enableNotificationBar_input: any;
	 enableDropDownSearch_input: any;
	 enablePageVirtualization_input: any;
	 waitingPopupTemplate_input: any;
	 dataSources_name_input: any;
	 dataSources_value_input: any;
	 exportSettings_exportOptions_input: any;
	 exportSettings_excelFormat_input: any;
	 exportSettings_wordFormat_input: any;
	 exportSettings_customItems_input: any;
	 pageSettings_orientation_input: any;
	 pageSettings_paperSize_input: any;
	 pageSettings_height_input: any;
	 pageSettings_width_input: any;
	 pageSettings_margins_input: any;
	 parameters_labels_input: any;
	 parameters_name_input: any;
	 parameters_nullable_input: any;
	 parameters_prompt_input: any;
	 parameters_values_input: any;
	 parameterSettings_delimiterChar_input: any;
	 parameterSettings_popupHeight_input: any;
	 parameterSettings_popupWidth_input: any;
	 parameterSettings_itemWidth_input: any;
	 parameterSettings_labelWidth_input: any;
	 parameterSettings_hideParameterBlock_input: any;
	 toolbarSettings_click_input: any;
	 toolbarSettings_items_input: any;
	 toolbarSettings_showToolbar_input: any;
	 toolbarSettings_showTooltip_input: any;
	 toolbarSettings_templateId_input: any;
	 toolbarSettings_customItems_input: any;
	 toolbarSettings_customGroups_input: any;


	 drillThrough_output : any = new EventEmitter();
	 renderingBegin_output : any = new EventEmitter();
	 renderingComplete_output : any = new EventEmitter();
	 reportError_output : any = new EventEmitter();
	 reportExport_output : any = new EventEmitter();
	 reportLoaded_output : any = new EventEmitter();
	 showError_output : any = new EventEmitter();
	 viewReportClick_output : any = new EventEmitter();
	 ajaxBeforeLoad_output : any = new EventEmitter();
	 ajaxSuccess_output : any = new EventEmitter();
	 ajaxError_output : any = new EventEmitter();
	 toolbarRendering_output : any = new EventEmitter();
	 exportProgressChanged_output : any = new EventEmitter();
	 printProgressChanged_output : any = new EventEmitter();
	 exportItemClick_output : any = new EventEmitter();
	 toolBarItemClick_output : any = new EventEmitter();
	 hyperlink_output : any = new EventEmitter();
	 reportPrint_output : any = new EventEmitter();
/**
 * @param {?} el
 * @param {?} cdRef
 * @param {?} _ejIterableDiffers
 * @param {?} _ejkeyvaluediffers
 */
constructor(public el: ElementRef,
public cdRef: ChangeDetectorRef,
private _ejIterableDiffers: IterableDiffers,
private _ejkeyvaluediffers: KeyValueDiffers) {
        super('BoldReportViewer', el, cdRef, [], _ejIterableDiffers, _ejkeyvaluediffers);
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'bold-reportviewer',
    template: ''}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: ChangeDetectorRef, },
{type: IterableDiffers, },
{type: KeyValueDiffers, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'dataSources_input': [{ type: Input, args: ['dataSources', ] },],
'enablePageCache_input': [{ type: Input, args: ['enablePageCache', ] },],
'exportSettings_input': [{ type: Input, args: ['exportSettings', ] },],
'isResponsive_input': [{ type: Input, args: ['isResponsive', ] },],
'locale_input': [{ type: Input, args: ['locale', ] },],
'pageSettings_input': [{ type: Input, args: ['pageSettings', ] },],
'parameters_input': [{ type: Input, args: ['parameters', ] },],
'toolbarSettings_input': [{ type: Input, args: ['toolbarSettings', ] },],
'parameterSettings_input': [{ type: Input, args: ['parameterSettings', ] },],
'printMode_input': [{ type: Input, args: ['printMode', ] },],
'printOption_input': [{ type: Input, args: ['printOption', ] },],
'processingMode_input': [{ type: Input, args: ['processingMode', ] },],
'renderMode_input': [{ type: Input, args: ['renderMode', ] },],
'reportPath_input': [{ type: Input, args: ['reportPath', ] },],
'reportServerUrl_input': [{ type: Input, args: ['reportServerUrl', ] },],
'reportServiceUrl_input': [{ type: Input, args: ['reportServiceUrl', ] },],
'zoomFactor_input': [{ type: Input, args: ['zoomFactor', ] },],
'serviceAuthorizationToken_input': [{ type: Input, args: ['serviceAuthorizationToken', ] },],
'enableParameterBlockScroller_input': [{ type: Input, args: ['enableParameterBlockScroller', ] },],
'enableDatasourceBlockScroller_input': [{ type: Input, args: ['enableDatasourceBlockScroller', ] },],
'sizeToReportContent_input': [{ type: Input, args: ['sizeToReportContent', ] },],
'autoRender_input': [{ type: Input, args: ['autoRender', ] },],
'enableNotificationBar_input': [{ type: Input, args: ['enableNotificationBar', ] },],
'enableDropDownSearch_input': [{ type: Input, args: ['enableDropDownSearch', ] },],
'enablePageVirtualization_input': [{ type: Input, args: ['enablePageVirtualization', ] },],
'waitingPopupTemplate_input': [{ type: Input, args: ['waitingPopupTemplate', ] },],
'dataSources_name_input': [{ type: Input, args: ['dataSources.name', ] },],
'dataSources_value_input': [{ type: Input, args: ['dataSources.value', ] },],
'exportSettings_exportOptions_input': [{ type: Input, args: ['exportSettings.exportOptions', ] },],
'exportSettings_excelFormat_input': [{ type: Input, args: ['exportSettings.excelFormat', ] },],
'exportSettings_wordFormat_input': [{ type: Input, args: ['exportSettings.wordFormat', ] },],
'exportSettings_customItems_input': [{ type: Input, args: ['exportSettings.customItems', ] },],
'pageSettings_orientation_input': [{ type: Input, args: ['pageSettings.orientation', ] },],
'pageSettings_paperSize_input': [{ type: Input, args: ['pageSettings.paperSize', ] },],
'pageSettings_height_input': [{ type: Input, args: ['pageSettings.height', ] },],
'pageSettings_width_input': [{ type: Input, args: ['pageSettings.width', ] },],
'pageSettings_margins_input': [{ type: Input, args: ['pageSettings.margins', ] },],
'parameters_labels_input': [{ type: Input, args: ['parameters.labels', ] },],
'parameters_name_input': [{ type: Input, args: ['parameters.name', ] },],
'parameters_nullable_input': [{ type: Input, args: ['parameters.nullable', ] },],
'parameters_prompt_input': [{ type: Input, args: ['parameters.prompt', ] },],
'parameters_values_input': [{ type: Input, args: ['parameters.values', ] },],
'parameterSettings_delimiterChar_input': [{ type: Input, args: ['parameterSettings.delimiterChar', ] },],
'parameterSettings_popupHeight_input': [{ type: Input, args: ['parameterSettings.popupHeight', ] },],
'parameterSettings_popupWidth_input': [{ type: Input, args: ['parameterSettings.popupWidth', ] },],
'parameterSettings_itemWidth_input': [{ type: Input, args: ['parameterSettings.itemWidth', ] },],
'parameterSettings_labelWidth_input': [{ type: Input, args: ['parameterSettings.labelWidth', ] },],
'parameterSettings_hideParameterBlock_input': [{ type: Input, args: ['parameterSettings.hideParameterBlock', ] },],
'toolbarSettings_click_input': [{ type: Input, args: ['toolbarSettings.click', ] },],
'toolbarSettings_items_input': [{ type: Input, args: ['toolbarSettings.items', ] },],
'toolbarSettings_showToolbar_input': [{ type: Input, args: ['toolbarSettings.showToolbar', ] },],
'toolbarSettings_showTooltip_input': [{ type: Input, args: ['toolbarSettings.showTooltip', ] },],
'toolbarSettings_templateId_input': [{ type: Input, args: ['toolbarSettings.templateId', ] },],
'toolbarSettings_customItems_input': [{ type: Input, args: ['toolbarSettings.customItems', ] },],
'toolbarSettings_customGroups_input': [{ type: Input, args: ['toolbarSettings.customGroups', ] },],
'drillThrough_output': [{ type: Output, args: ['drillThrough', ] },],
'renderingBegin_output': [{ type: Output, args: ['renderingBegin', ] },],
'renderingComplete_output': [{ type: Output, args: ['renderingComplete', ] },],
'reportError_output': [{ type: Output, args: ['reportError', ] },],
'reportExport_output': [{ type: Output, args: ['reportExport', ] },],
'reportLoaded_output': [{ type: Output, args: ['reportLoaded', ] },],
'showError_output': [{ type: Output, args: ['showError', ] },],
'viewReportClick_output': [{ type: Output, args: ['viewReportClick', ] },],
'ajaxBeforeLoad_output': [{ type: Output, args: ['ajaxBeforeLoad', ] },],
'ajaxSuccess_output': [{ type: Output, args: ['ajaxSuccess', ] },],
'ajaxError_output': [{ type: Output, args: ['ajaxError', ] },],
'toolbarRendering_output': [{ type: Output, args: ['toolbarRendering', ] },],
'exportProgressChanged_output': [{ type: Output, args: ['exportProgressChanged', ] },],
'printProgressChanged_output': [{ type: Output, args: ['printProgressChanged', ] },],
'exportItemClick_output': [{ type: Output, args: ['exportItemClick', ] },],
'toolBarItemClick_output': [{ type: Output, args: ['toolBarItemClick', ] },],
'hyperlink_output': [{ type: Output, args: ['hyperlink', ] },],
'reportPrint_output': [{ type: Output, args: ['reportPrint', ] },],
};
}

function BoldReportViewerComponent_tsickle_Closure_declarations() {
/** @type {?} */
BoldReportViewerComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
BoldReportViewerComponent.ctorParameters;
/** @type {?} */
BoldReportViewerComponent.propDecorators;
/** @type {?} */
BoldReportViewerComponent.prototype.dataSources_input;
/** @type {?} */
BoldReportViewerComponent.prototype.enablePageCache_input;
/** @type {?} */
BoldReportViewerComponent.prototype.exportSettings_input;
/** @type {?} */
BoldReportViewerComponent.prototype.isResponsive_input;
/** @type {?} */
BoldReportViewerComponent.prototype.locale_input;
/** @type {?} */
BoldReportViewerComponent.prototype.pageSettings_input;
/** @type {?} */
BoldReportViewerComponent.prototype.parameters_input;
/** @type {?} */
BoldReportViewerComponent.prototype.toolbarSettings_input;
/** @type {?} */
BoldReportViewerComponent.prototype.parameterSettings_input;
/** @type {?} */
BoldReportViewerComponent.prototype.printMode_input;
/** @type {?} */
BoldReportViewerComponent.prototype.printOption_input;
/** @type {?} */
BoldReportViewerComponent.prototype.processingMode_input;
/** @type {?} */
BoldReportViewerComponent.prototype.renderMode_input;
/** @type {?} */
BoldReportViewerComponent.prototype.reportPath_input;
/** @type {?} */
BoldReportViewerComponent.prototype.reportServerUrl_input;
/** @type {?} */
BoldReportViewerComponent.prototype.reportServiceUrl_input;
/** @type {?} */
BoldReportViewerComponent.prototype.zoomFactor_input;
/** @type {?} */
BoldReportViewerComponent.prototype.serviceAuthorizationToken_input;
/** @type {?} */
BoldReportViewerComponent.prototype.enableParameterBlockScroller_input;
/** @type {?} */
BoldReportViewerComponent.prototype.enableDatasourceBlockScroller_input;
/** @type {?} */
BoldReportViewerComponent.prototype.sizeToReportContent_input;
/** @type {?} */
BoldReportViewerComponent.prototype.autoRender_input;
/** @type {?} */
BoldReportViewerComponent.prototype.enableNotificationBar_input;
/** @type {?} */
BoldReportViewerComponent.prototype.enableDropDownSearch_input;
/** @type {?} */
BoldReportViewerComponent.prototype.enablePageVirtualization_input;
/** @type {?} */
BoldReportViewerComponent.prototype.waitingPopupTemplate_input;
/** @type {?} */
BoldReportViewerComponent.prototype.dataSources_name_input;
/** @type {?} */
BoldReportViewerComponent.prototype.dataSources_value_input;
/** @type {?} */
BoldReportViewerComponent.prototype.exportSettings_exportOptions_input;
/** @type {?} */
BoldReportViewerComponent.prototype.exportSettings_excelFormat_input;
/** @type {?} */
BoldReportViewerComponent.prototype.exportSettings_wordFormat_input;
/** @type {?} */
BoldReportViewerComponent.prototype.exportSettings_customItems_input;
/** @type {?} */
BoldReportViewerComponent.prototype.pageSettings_orientation_input;
/** @type {?} */
BoldReportViewerComponent.prototype.pageSettings_paperSize_input;
/** @type {?} */
BoldReportViewerComponent.prototype.pageSettings_height_input;
/** @type {?} */
BoldReportViewerComponent.prototype.pageSettings_width_input;
/** @type {?} */
BoldReportViewerComponent.prototype.pageSettings_margins_input;
/** @type {?} */
BoldReportViewerComponent.prototype.parameters_labels_input;
/** @type {?} */
BoldReportViewerComponent.prototype.parameters_name_input;
/** @type {?} */
BoldReportViewerComponent.prototype.parameters_nullable_input;
/** @type {?} */
BoldReportViewerComponent.prototype.parameters_prompt_input;
/** @type {?} */
BoldReportViewerComponent.prototype.parameters_values_input;
/** @type {?} */
BoldReportViewerComponent.prototype.parameterSettings_delimiterChar_input;
/** @type {?} */
BoldReportViewerComponent.prototype.parameterSettings_popupHeight_input;
/** @type {?} */
BoldReportViewerComponent.prototype.parameterSettings_popupWidth_input;
/** @type {?} */
BoldReportViewerComponent.prototype.parameterSettings_itemWidth_input;
/** @type {?} */
BoldReportViewerComponent.prototype.parameterSettings_labelWidth_input;
/** @type {?} */
BoldReportViewerComponent.prototype.parameterSettings_hideParameterBlock_input;
/** @type {?} */
BoldReportViewerComponent.prototype.toolbarSettings_click_input;
/** @type {?} */
BoldReportViewerComponent.prototype.toolbarSettings_items_input;
/** @type {?} */
BoldReportViewerComponent.prototype.toolbarSettings_showToolbar_input;
/** @type {?} */
BoldReportViewerComponent.prototype.toolbarSettings_showTooltip_input;
/** @type {?} */
BoldReportViewerComponent.prototype.toolbarSettings_templateId_input;
/** @type {?} */
BoldReportViewerComponent.prototype.toolbarSettings_customItems_input;
/** @type {?} */
BoldReportViewerComponent.prototype.toolbarSettings_customGroups_input;
/** @type {?} */
BoldReportViewerComponent.prototype.drillThrough_output;
/** @type {?} */
BoldReportViewerComponent.prototype.renderingBegin_output;
/** @type {?} */
BoldReportViewerComponent.prototype.renderingComplete_output;
/** @type {?} */
BoldReportViewerComponent.prototype.reportError_output;
/** @type {?} */
BoldReportViewerComponent.prototype.reportExport_output;
/** @type {?} */
BoldReportViewerComponent.prototype.reportLoaded_output;
/** @type {?} */
BoldReportViewerComponent.prototype.showError_output;
/** @type {?} */
BoldReportViewerComponent.prototype.viewReportClick_output;
/** @type {?} */
BoldReportViewerComponent.prototype.ajaxBeforeLoad_output;
/** @type {?} */
BoldReportViewerComponent.prototype.ajaxSuccess_output;
/** @type {?} */
BoldReportViewerComponent.prototype.ajaxError_output;
/** @type {?} */
BoldReportViewerComponent.prototype.toolbarRendering_output;
/** @type {?} */
BoldReportViewerComponent.prototype.exportProgressChanged_output;
/** @type {?} */
BoldReportViewerComponent.prototype.printProgressChanged_output;
/** @type {?} */
BoldReportViewerComponent.prototype.exportItemClick_output;
/** @type {?} */
BoldReportViewerComponent.prototype.toolBarItemClick_output;
/** @type {?} */
BoldReportViewerComponent.prototype.hyperlink_output;
/** @type {?} */
BoldReportViewerComponent.prototype.reportPrint_output;
/** @type {?} */
BoldReportViewerComponent.prototype.el;
/** @type {?} */
BoldReportViewerComponent.prototype.cdRef;
/** @type {?} */
BoldReportViewerComponent.prototype._ejIterableDiffers;
/** @type {?} */
BoldReportViewerComponent.prototype._ejkeyvaluediffers;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
